<template>
  <div class="social-wrap" :class="{ 'no-cursor': bindAccountNum === 1 && isBind }" @click="refreshBindInfo">
    <div class="logo-wrap">
      <span class="logo facebook"></span>
      <span class="name">Facebook</span>
    </div>
    <div class="account-name" :class="{ 'no-arr': bindAccountNum === 1 && isBind }">
      <template v-if="isBind">{{ isBind }}</template>
      <template v-else>{{ $t('web_unbind') }}</template>
    </div>
  </div>
</template>

<script>
import { mapState, mapMutations, mapGetters } from 'vuex'
import FetchBindInfo from '@/mixins/fetchBindInfo'
import AccountBind from '@/mixins/accountBind'
export default {
  name: 'AccountFacebook',
  mixins: [FetchBindInfo, AccountBind],
  data () {
    return {
      visible: false,
      userInfo: {},
      once_key: undefined
    }
  },
  computed: {
    ...mapGetters(['bindAccountNum']),
    ...mapState({
      bindInfo: state => state.bindInfo.facebook
    }),
    isBind () {
      return this.bindInfo.name || this.bindInfo.email || ''
    }
  },
  methods: {
    ...mapMutations({
      setBindInfoItem: 'setBindInfoItem'
    }),
    refreshBindInfo () {
      if (!window.FB) return
      if (this.isBind) {
        if (this.bindAccountNum <= 1) return
        this.mixinsRefreshBindInfo('loginClick')
      } else {
        this.loginClick()
      }
    },
    loginClick () {
      if (!window.FB) return
      if (this.isBind) {
        if (this.bindAccountNum <= 1) return
        this.$dialog(
          {
            title: this.$t('web_tips_title'),
            text: this.$t('web_unbind_tips', { 0: 'Facebook' }),
            confirmTxt: this.$t('test_confirm'),
            cancelTxt: this.$t('test_cancel')
          },
          this.onFBLogin
        )
      } else {
        this.onFBLogin()
      }
    },
    onFBLogin () {
      const _this = this
      // 检测FB登录状态
      window.FB.logout()
      window.FB.login(function (loginRes) {
        _this.$Spin.show()
        if (loginRes.status === 'connected') {
          // Logged into your webpage and Facebook.
          const authResponse = loginRes.authResponse
          window.FB.api('/me', function (profileRes) {
            if (!profileRes.id) {
              _this.$msg.success(_this.$t('web_bind_fail'))
              window.FB.logout()
              this.$Spin.hide()
              return
            }
            console.log('authResponse', authResponse, profileRes)
            _this.userInfo = {
              id: profileRes.id || '',
              name: profileRes.name,
              token: authResponse.accessToken,
              type: 'facebook',
              expire: authResponse.expiresIn
            }
            if (_this.isBind) {
              _this.unbind()
            } else {
              _this.bind()
            }
          })
        } else {
          _this.$msg.success(_this.$t('web_bind_fail'))
          _this.$Spin.hide()
        }
      }, { scope: 'public_profile, email' })
    },
    bind () {
      this.once_key = this.$utils.getTS()
      this.$Spin.show()
      this.doBind({ bindType: this.$ENUM.SOCIAL_CODE_MAP.facebook, ...this.userInfo })
    },
    bindHandler (resp) {
      console.log('==z==> FB bindHandler ', resp)
      this.$Spin.hide()
      if (resp.accountId) {
        const bindInfo = ((resp.bindInfos || []).filter(item => Number(item.bindType) === this.$ENUM.SOCIAL_CODE_MAP.facebook)[0] || {}).bindInfo
        this.setBindInfoItem({
          key: 'facebook',
          value: {
            ...bindInfo
          }
        })
        this.$msg.success(this.$t('web_bind_ok'))
      } else {
        const msg = this.$t(`KGSDK_${resp.code}`) === `KGSDK_${resp.code}` ? this.$t('web_bind_fail') : this.$t(`KGSDK_${resp.code}`)
        this.$msg.success(msg)
      }
    },
    unbind () {
      this.once_key = this.$utils.getTS()
      this.$Spin.show()
      this.doUnBind({ bindType: this.$ENUM.SOCIAL_CODE_MAP.facebook, ...this.bindInfo })
    },
    unbindHandler (resp) {
      this.$Spin.hide()
      if (resp.accountId) {
        this.setBindInfoItem({
          key: 'facebook',
          value: {
            name: '',
            id: '',
            email: ''
          }
        })
        window.unbindClose()
        this.$msg.success(this.$t('web_tips_unbind'))
      } else {
        this.$msg.success(this.$t(`KGSDK_${resp.code}`))
      }
    }
  }
}
</script>

<style lang='less' scoped >
@import url('@/assets/styles/account.less');
</style>
